import React from "react";
import canUseDOM from "../canUseDOM.mjs";
const useLayoutEffectImpl = canUseDOM ? React.useLayoutEffect : React.useEffect;
var useLayoutEffect_default = useLayoutEffectImpl;
export { useLayoutEffect_default as default };
//# sourceMappingURL=index.mjs.map
